// @ts-nocheck


import React, { Component } from 'react';
import { navigate } from '../../../lib/routerAdapter';
import styled from 'styled-components';
import moment from 'moment';

import Button from 'antd/lib/button';
import notification from 'antd/lib/notification';

import { DatePicker } from '../../../components/ant/DatePicker';


import { formatDateTimeToISOString, goBack } from '../../../lib/helpers';
import { measuringDeviceCertificationApi } from './../../../lib/api';

import { Panel, Section } from './../../../components/layout';
import Grid, { GridItem } from './../../../components/layout/Grid';
import { Selects, Form } from './../../../components';
import Header from './../../../components/layout/Header';
import Breadcrumbs, { Crumb } from './../../../components/layout/Breadcrumbs';
import { notificationLoading } from '../../../components/Notifications';
import CancelButton from '../../../components/CancelButton';
import { InputNumber } from '../../../components/inputs';

const { VehicleSelect } = Selects;

const Content = styled.div.withConfig({ displayName: "Form__Content", componentId: "sc-puv29i-0" })(["padding:16px;"]);


const StyledPanel = styled(Panel).withConfig({ displayName: "Form__StyledPanel", componentId: "sc-puv29i-1" })(["padding-top:0;"]);


const Footer = styled(Section).withConfig({ displayName: "Form__Footer", componentId: "sc-puv29i-2" })(["padding:16px;display:flex;justify-content:space-between;align-items:center;"]);













const InnerForm = ({
  onSubmit,
  onCancel,
  measuringDeviceCertification,
  showVehicleSelect
}) =>
<Form initialValues={measuringDeviceCertification} onSubmit={onSubmit}>
    {(FormField, formikProps) => {
    const { handleSubmit, handleBlur, setFieldValue, dirty } = formikProps;
    return (
      <form onSubmit={handleSubmit}>
          <Section>
            <Content>
              <Grid gutter="16px">
                {showVehicleSelect &&
              <GridItem>
                    <FormField label="ТС" required name="vehicleId">
                      {({ name, value }) =>
                  <VehicleSelect
                    name={name}
                    value={value}
                    onBlur={() => handleBlur({ target: { name } })}
                    onChange={(value) =>
                    setFieldValue(name, value)
                    }
                    data-cy="vehicleSelect" />

                  }
                    </FormField>
                  </GridItem>
              }
                <GridItem>
                  <FormField
                  fast
                  label="Дата сертификации"
                  name="maintenanceDate"
                  required>

                    {({ value, name }) =>
                  <DatePicker
                    format="DD.MM.YYYY"
                    value={value ? moment(value) : null}
                    onChange={(value, dateString) => {
                      setFieldValue(
                        name,
                        formatDateTimeToISOString(value, dateString)
                      );
                    }} />

                  }
                  </FormField>
                </GridItem>
                <GridItem>
                  <FormField
                  fast
                  label="След. дата сертификации"
                  name="nextActDate">

                    {({ value, name }) =>
                  <DatePicker
                    format="DD.MM.YYYY"
                    value={value ? moment(value) : null}
                    onChange={(value, dateString) => {
                      setFieldValue(
                        name,
                        formatDateTimeToISOString(value, dateString)
                      );
                    }} />

                  }
                  </FormField>
                </GridItem>
                <GridItem>
                  <FormField
                  fast
                  label="Сумма оплаты, руб."
                  name="paymentAmount"
                  required>

                    {({ name, value }) =>
                  <InputNumber
                    decimalSeparator=","
                    name={name}
                    value={value}
                    onChange={(value) => setFieldValue(name, value)} />

                  }
                  </FormField>
                </GridItem>
              </Grid>
            </Content>
          </Section>
          <Footer>
            <Button type="primary" htmlType="submit" data-cy="save">
              Сохранить
            </Button>
            <CancelButton dirty={dirty} onClick={onCancel}>
              Отменить
            </CancelButton>
          </Footer>
        </form>);

  }}
  </Form>;











class MeasuringDeviceCertificationForm extends Component {
  state = {};

  async componentDidMount() {
    try {
      const measuringDeviceCertificationId = parseInt(
        this.props.measuringDeviceCertificationId,
        10
      );
      const vehicleId = parseInt(this.props.vehicleId, 10);

      if (measuringDeviceCertificationId) {
        const measuringDeviceCertification = await measuringDeviceCertificationApi.fetchMeasuringDeviceCertification(
          measuringDeviceCertificationId
        );
        this.setState({
          measuringDeviceCertification
        });
      } else if (vehicleId) {
        this.setState({
          measuringDeviceCertification: {
            vehicleId
          }
        });
      } else {
        this.setState({
          measuringDeviceCertification: {}
        });
      }
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
      this.redirect();
    }
  }

  redirect = (id = this.props.measuringDeviceCertificationId) => {
    if (this.props.vehicleId) {
      // Делаем именно переход, т.к. нам нужен скролл до блока сертификаций средств измерений
      navigate(
        `/vehicles/${this.props.vehicleId}/maintenance/measuring-device-certifications`
      );
    } else {
      goBack(`/services/measuring-device-certifications/${id || ''}`);
    }
  };

  onSubmit = async (
  measuringDeviceCertification) =>
  {
    try {
      notificationLoading({
        message: 'Сохранение данных...',
        key: 'saving'
      });
      const measuringDeviceCertificationId = parseInt(
        this.props.measuringDeviceCertificationId,
        10
      );
      if (measuringDeviceCertificationId) {
        await measuringDeviceCertificationApi.updateMeasuringDeviceCertification(
          measuringDeviceCertification
        );
        notification.success({
          message: 'Успешное обновление',
          description: 'Данные были успешно обновлены'
        });
        this.redirect(measuringDeviceCertificationId);
      } else {
        const added = await measuringDeviceCertificationApi.addMeasuringDeviceCertification(
          measuringDeviceCertification
        );

        notification.success({
          message: 'Успешное добавление',
          description: `Cертификация средств измерений успешно добавлен`
        });
        this.redirect(added.id);
      }
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('saving');
    }
  };

  render() {
    const measuringDeviceCertificationId = parseInt(
      this.props.measuringDeviceCertificationId,
      10
    );
    const vehicleId = parseInt(this.props.vehicleId, 10);
    const { measuringDeviceCertification } = this.state;
    return (
      <>
        <Header
          left={
          <Breadcrumbs>
              <Crumb to="/">Главная</Crumb>
              {vehicleId > 0 ?
            <Crumb
              to={`/vehicles/${vehicleId}/maintenance/measuring-device-certification`}>

                  ТС
                </Crumb> :

            <Crumb to={'/services/measuring-device-certifications'}>
                  Список сертификаций средств измерений
                </Crumb>
            }
              {measuringDeviceCertificationId ?
            <Crumb>Редактирование сертификаций средств измерений</Crumb> :

            <Crumb>Новая сертификация средств измерений</Crumb>
            }
            </Breadcrumbs>
          } />

        <StyledPanel>
          <h1>
            {measuringDeviceCertificationId ?
            `Сертификация средств измерений №${measuringDeviceCertificationId}` :
            'Тарировка цистерн'}
          </h1>
        </StyledPanel>
        <InnerForm
          measuringDeviceCertification={measuringDeviceCertification}
          onSubmit={this.onSubmit}
          onCancel={() =>
          this.redirect(
            measuringDeviceCertification.id || measuringDeviceCertificationId
          )
          }
          showVehicleSelect={!this.props.vehicleId} />

      </>);

  }
}

export default MeasuringDeviceCertificationForm;
